import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-zpt-contacts',
  templateUrl: './zpt-contacts.page.html',
  styleUrls: ['./zpt-contacts.page.scss'],
})
export class ZptContactsPage {
  // declared variables
  public assets = environment.assets;
  // constructor
  constructor() { }
  //opens email client (iOS workaround)
  public openEmail(email) {
    window.location.href = 'mailto:'+ email; 
    return false;
  }
}
